import { request } from '@umijs/max';

// 获取字典列表
export async function getAdmDicPage({
  pageSize,
  current,
  filter,
  sorter,
}: {
  pageSize: number;
  current: number;
  filter: API.FormValues;
  sorter: string;
}) {
  return request('/api/super/sysDic/page', {
    method: 'POST',
    data: {
      pageSize,
      current,
      filter,
      sorter,
    },
  });
}

// 获取全部字典
export async function getAdmDicAll({ filter }: { filter: API.FormValues }) {
  return request('/api/super/sysDic/all', {
    method: 'POST',
    data: {
      filter,
    },
  });
}

// 获取字典详情
export async function getAdmDicInfo(values: API.FormValues) {
  return request('/api/super/sysDic/info', {
    method: 'POST',
    data: values,
  });
}

// 创建字典
export async function addAdmDic(values: API.FormValues) {
  return request('/api/super/sysDic/add', {
    method: 'POST',
    data: values,
  });
}

// 编辑字典
export async function editAdmDic(values: API.FormValues) {
  return request('/api/super/sysDic/edit', {
    method: 'POST',
    data: values,
  });
}

// 删除字典
export async function removeAdmDic(values: API.FormValues) {
  return request('/api/super/sysDic/remove', {
    method: 'POST',
    data: values,
  });
}

// 根据key获取字典项
export async function getDicByKey(values: API.FormValues) {
  return request('/api/super/util/sysDic', {
    method: 'POST',
    data: values,
  });
}
